module.exports = __webpack_public_path__ + "static/media/strefa-ofert-pracy.3d697451.svg";